import { useMutation } from "@tanstack/react-query";

import {
  downloadCostAnalysisForTask,
  downloadRoiReportForTask,
  downloadQuoteForTask,
  downloadSupportResponseForTask,
  type CostAnalysisTaskRequest,
  type DocumentFormat,
  type QuoteRenderRequest,
  type RoiReportTaskRequest,
} from "../api/quoteDocuments";

export function useDownloadCostAnalysis() {
  return useMutation<
    void,
    Error,
    { taskId: string; body?: CostAnalysisTaskRequest }
  >({
    mutationFn: ({ taskId, body }) => downloadCostAnalysisForTask(taskId, body),
  });
}

export function useDownloadRoiReport() {
  return useMutation<
    void,
    Error,
    { taskId: string; body?: RoiReportTaskRequest }
  >({
    mutationFn: ({ taskId, body }) => downloadRoiReportForTask(taskId, body),
  });
}

export function useDownloadSupportResponse() {
  return useMutation<void, Error, { taskId: string; format: DocumentFormat }>({
    mutationFn: ({ taskId, format }) =>
      downloadSupportResponseForTask(taskId, format),
  });
}

export function useDownloadQuote() {
  return useMutation<
    void,
    Error,
    { taskId: string; body?: QuoteRenderRequest }
  >({
    mutationFn: ({ taskId, body }) => downloadQuoteForTask(taskId, body),
  });
}
